import { maskString, nameMask } from 'smartpi-core';

import { noMaskingManager } from '../services/noMasking';

function mobileMasking(mobile: string | undefined) {
  if (!mobile) {
    return '-';
  }

  if (isNaN(Number(mobile)) || mobile.length !== 11) {
    return '-';
  }

  const isNoMasking = noMaskingManager.getNoMasking();
  if (isNoMasking) {
    return mobile;
  }

  return maskString(mobile, 3, 7);
}

function nameMasking(name: string | undefined) {
  if (!name) {
    return '-';
  }

  const isNoMasking = noMaskingManager.getNoMasking();
  if (isNoMasking) {
    return name;
  }

  return nameMask(name);
}

export { mobileMasking, nameMasking };



// WEBPACK FOOTER //
// ./src/utils/masking.ts